import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.FeedbackButton.title',
    defaultMessage: 'Send feedback',
  },
})
